// @ts-nocheck
import { capitalize } from 'lodash';
import { useIntl } from 'react-intl';

export const DATE = ['hour', 'day', 'week', 'month', 'year', 'hod', 'dow', 'mod', 'mow'];

type Options = {
  id: string;
  label: string;
};

export const useTimeFrameOptions = (): Options[] => {
  const { formatMessage } = useIntl();

  return DATE.map(option => ({
    id: option,
    label: formatMessage({
      defaultMessage: capitalize(option),
      id: `reporting.cpy${capitalize(option)}`
    })
  }));
};
